"use client";

import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { PageTypePortal } from "@/lib/types";
import { getPostAuthRedirectPath } from "@/lib/utils/auth/postAuthRedirect";
import { useTenantData } from "@/hooks";
import { getTenantDisplayName } from "@/lib/utils/tenant";
import { AuthRedirectView } from "./AuthRedirectView";

export const SignInSuccessView = () => {
  const searchParams = useSearchParams();
  const { tenantData } = useTenantData();
  const studioName = getTenantDisplayName(tenantData);

  const redirectPath = useMemo(
    () => getPostAuthRedirectPath(searchParams.get("callbackUrl")),
    [searchParams],
  );

  const isClassRegistrationRedirect = redirectPath.startsWith(
    PageTypePortal.ClassRegistration,
  );

  const statusMessage = isClassRegistrationRedirect
    ? "Opening class registration…"
    : studioName
      ? `Opening your dashboard at ${studioName}…`
      : "Opening your dashboard…";

  return (
    <AuthRedirectView
      redirectPath={redirectPath}
      title="Welcome back"
      statusMessage={statusMessage}
      showLogo
    />
  );
};
